var exports = {
  "Kk": "CallMessage.module__icon___c2F4Qk",
  "mR": "CallMessage.module__iconActive___c2F4Qk",
  "Ap": "CallMessage.module__iconEnded___c2F4Qk",
  "bp": "CallMessage.module__iconMissed___c2F4Qk",
  "x": "CallMessage.module__callLink___c2F4Qk",
};

module.exports = exports;
